import { render, staticRenderFns } from "./ClassifyTreeV2.vue?vue&type=template&id=f046b5c8&scoped=true"
import script from "./ClassifyTreeV2.vue?vue&type=script&lang=js"
export * from "./ClassifyTreeV2.vue?vue&type=script&lang=js"
import style0 from "./ClassifyTreeV2.vue?vue&type=style&index=0&id=f046b5c8&prod&lang=less&scoped=true"
import style1 from "./ClassifyTreeV2.vue?vue&type=style&index=1&id=f046b5c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f046b5c8",
  null
  
)

export default component.exports